import React from 'react';
import { Flex, Text } from '@amzn/storm-ui';
import { MobileLinksWrapper } from './Footer.styles';
import { FooterComponentProps } from './Footer.types';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { StyledLink } from 'src/commons/components/StyledLink';

const Mobile: React.VFC<FooterComponentProps> = ({
  copyright,
  links,
  toggleText,
  toggleView,
  isFooterLinkEnabled,
}) => (
  <Flex
    id="footer"
    direction="column"
    justifyContent="center"
    alignItems="center"
    rowGap="xxsmall"
  >
    {isFooterLinkEnabled === true && toggleText && toggleView && (
      <StyledLink onClick={toggleView}>{toggleText}</StyledLink>
    )}
    <Text color="secondary">{copyright}</Text>
    {links.length > 0 && (
      <MobileLinksWrapper>
        {links.map((link) => (
          <StyledLink
            key={link.label}
            href={link.url}
            {...getTaktAttributes('link', chromeComponents.FOOTER, {
              url: link.url,
              label: link.label,
            })}
          >
            {link.label}
          </StyledLink>
        ))}
      </MobileLinksWrapper>
    )}
  </Flex>
);

export default Mobile;
